import { PATH_SETTINGS_PAYROLL } from "../../../../Settings/paths";
import { NotificationTemplate } from "../index";

export const Payroll: NotificationTemplate<undefined> = {
  renderTitle: props => "Run your first payroll",
  renderBody: props => {
    return "Set your payroll preferences and start your payroll experience. Task will be marked as completed upon your first payroll run.";
  },
  buttonAction: (props, history) => () => {
    return history.push(PATH_SETTINGS_PAYROLL);
  },
  buttonText: () => "Run payroll"
};
